// components/ui/Dialog.tsx — Radix UI Dialog primitive wrapper

import type { ReactNode } from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import styles from './Dialog.module.css';

export interface DialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children?: ReactNode;
  actions?: ReactNode;
  showCloseButton?: boolean;
}

export function Dialog({
  isOpen,
  onOpenChange,
  title,
  description,
  children,
  actions,
  showCloseButton = true,
}: DialogProps) {
  return (
    <RadixDialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className={styles.overlay} />
        <RadixDialog.Content className={styles.content}>
          <RadixDialog.Title className={styles.title}>
            {title}
          </RadixDialog.Title>

          {description && (
            <RadixDialog.Description className={styles.description}>
              {description}
            </RadixDialog.Description>
          )}

          {children}

          {actions && <div className={styles.actions}>{actions}</div>}

          {showCloseButton && (
            <RadixDialog.Close className={styles.closeBtn} aria-label="Close modal">
              ✕
            </RadixDialog.Close>
          )}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
